<template>
	<div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-md-8 mt-5 mb-3">
                <div class="card">
                    <div class="card-body">
                        <vue-recaptcha :sitekey="siteKey"
                                       @expired="onExpired"
                                       @verify="onVerify"
                                       ref="recaptcha"
                                       size="invisible">

                        </vue-recaptcha>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import isEmail from 'validator/lib/isEmail';
  	import isLength from 'validator/lib/isLength';
  	import { mapActions } from 'vuex';
  	import api from '../../api';
  	import { ERROR_MESSAGES, SITE_KEY_RECAPTCHA, ROUTER_NAMES } from '../../constants';
  	import VueRecaptcha from 'vue-recaptcha';


	export default {
	    name: 'VerifyEmailForm',
	    components: { VueRecaptcha },
	    data() {
	      return {
	        disabled: false,
	        siteKey: SITE_KEY_RECAPTCHA
	      };
	    },
	    computed: {
	    	email() {
	    		return this.$route.query.email;
	    	},
	    	token() {
	    		return this.$route.query.token;
	    	},
	    },
	    methods: {
	      onVerify(recaptcha) {
	      	api.auth.verifyEmailToken({
	      		email: this.email,
	      		token: this.token,
	      		recaptcha: recaptcha
	      	}).then(() => {
	      		this.disabled = false;
	      		this.$router.push({
	      			name: ROUTER_NAMES.LOGIN,
              query: {
	      			    "verify-success": true
              }
	      		});
	      	}, (e) => {
	      		this.disabled = false;
	      		this.$refs.recaptcha.reset();
            this.$router.push({
              name: ROUTER_NAMES.VERIFY_EMAIL_EXPIRED
            })
	      	})
	      },
	      onExpired() {
	        this.$router.push({
 				name: ROUTER_NAMES.VERIFY_EMAIL_EXPIRED
 			})
	      }
	    },
	    mounted() {
          	this.disabled = true;
            this.$refs.recaptcha.execute()
        }
	}
</script>
